import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { LocationsRepository } from "../../repositories";
import { LocationTag } from "../../domain/models/location-tag";

@Injectable({ providedIn: 'root' })
export class GetLocationTagsMlsUsecase implements UseCase<any|undefined, LocationTag[]> {

  constructor(private locationRepository: LocationsRepository) {
  }

  execute(): Observable<any | LocationTag[]>{
    return this.locationRepository.getTagsMLS();
  }

}
